export default __webpack_public_path__ + "static/media/ep4collage5.c16f8a20.jpg";